// Handle confuse targeting
import i18n from '../i18n';
import { getBattleActionBlockErrorKey } from '../utils/battleActionBlockError';

const targetConfuse = (targetZone, targetIndex, ws, setError, setConfuseTargetMode, setSelectedConfuseWeaponId) => {
  const blockKey = getBattleActionBlockErrorKey({
    requireGameId: false,
    socket: ws,
  });
  if (blockKey) {
    setError(i18n.t(blockKey));
    return;
  }

  // Determine if targeting friendly or opponent unit
  let targetUnitId = "friendly";
  let actualTargetZone = targetZone;

  // If targeting opponent zones, use opponent targeting
  if (targetZone === "opponent_front" || targetZone === "opponent_flank") {
    targetUnitId = "opponent";
    actualTargetZone = targetZone;
  }

  // Send confuse targeting action
  const action = {
    type: "targetConfuse", 
    targetUnitId: targetUnitId,
    targetZone: actualTargetZone,
    targetIndex: targetIndex
  };

  ws.send(JSON.stringify(action));
  
  // Reset confuse targeting
  setConfuseTargetMode(false);
  setSelectedConfuseWeaponId(null);
};

export default targetConfuse;
